import React from 'react'
import "./LoginBtn.css";

function LoginBtn() {
  return (
    <div>
        <button className="btn-53">
  <div className="original">Login</div>
  <div className="letters">
    
    <span>L</span>
    <span>o</span>
    <span>g</span>
    <span>i</span>
    <span>n</span>
  </div>
</button>
    </div>
  )
}

export default LoginBtn
